import React from 'react';

import CheckIcon from "@mui/icons-material/Check";
import BlockIcon from "@mui/icons-material/Block";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { IconButton, Tooltip, ClickAwayListener } from '@mui/material';

export default function ConfirmationButton({ tooltip, handleConfirm  }) {

    const [confirm, setConfirm] = React.useState(false);

    let buttonIcon = <DeleteIcon/>;

    const prepareToConfirm = () => {
        setConfirm(true);
    };

    const cancelConfirm = () => {
        setConfirm(false);
    };

    const handleConfirmClick = (e) => {
        handleConfirm(e);
        setConfirm(false);
    };

    // TODO: Use Theme RAG Colors
    return (
        <React.Fragment>
            {!confirm &&
                <Tooltip title={tooltip}>
                    <IconButton color="inherit" aria-label="confirm" onClick={prepareToConfirm} size="small">
                        {buttonIcon}
                    </IconButton>
                </Tooltip>
            }
            {confirm &&
                <ClickAwayListener onClickAway={cancelConfirm}>
                    <div style={{display: 'inline-flex'}}>
                        <Tooltip title={tooltip ? tooltip : "Confirm"}>
                            <IconButton color="inherit" aria-label="confirm" onClick={handleConfirmClick} size="small">
                                <CheckIcon style={{color: "green"}}/>
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Cancel">
                            <IconButton color="inherit" aria-label="cancel" onClick={cancelConfirm} size="small">
                                <BlockIcon style={{color: "red"}}/>
                            </IconButton>
                        </Tooltip>
                    </div>
                </ClickAwayListener>
            }
        </React.Fragment>
    );
}
